/* eslint-disable */

import * as Sentry from '@sentry/react';
import { fork, all, takeEvery, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
} from './redux';
import Request from 'app/utils/xhrWrapper';

export function* getProfile() {
  yield takeEvery(GET_PROFILE, function* () : any {
    try {
      const response = yield Request.get('partner/TV/profile');
      const responseData = _.get(response, ['data']);
      if (responseData && process.env.SKIP_SENTRY !== 'false') {
        Sentry.configureScope((scope : any) => {
          scope.clear();
          if (_.get(responseData, ['is_login'])) {
            scope.setUser({
              username: _.get(responseData, ['profile_info', 'username']),
            });
          } else {
            scope.setUser({});
          }
          scope.setTag('LG_APP', _.get(window, ['webOS', 'platform', 'tv']) ? 'YES' : 'NO');
        });
        yield put({ type: GET_PROFILE_SUCCESS, data: responseData });
      } else {
        yield put({ type: GET_PROFILE_FAIL, data: {} });
      }
    } catch (error) {
      yield put({ type: GET_PROFILE_FAIL, data: error });
    }
  });
}

export default function* () {
  yield all([
    fork(getProfile),
  ]);
}
